module.exports = __webpack_public_path__ + "img/pic-jinyue.21a2ec53.png";